import { View } from "react-native";
import { useTailwind } from "tailwind-rn";

import CancellationInfo from "./CancellationInfo";
import RecurrencePayments from "./RecurrencePayments";
import { Recurrence } from "../../../types";
import ActionButton from "../../ActionButton";
import CardText from "../../CardText";
import TransactionCard from "../../TransactionCard";

type Props = {
  recurrence?: Recurrence;
};

export default function RecurrenceCard({ recurrence }: Props) {
  const tailwind = useTailwind();
  if (!recurrence) {
    return null;
  }

  const { type, payments, interval, cancellationInfo, availableActions } =
    recurrence;

  return (
    <TransactionCard>
      <CardText.Title text={type} />
      <RecurrencePayments payments={payments} />

      <View style={tailwind("mt-2")}>
        <CardText.Subtitle text="Periodicidad" />
        <CardText.Body text={interval} />
      </View>
      <CancellationInfo cancellationInfo={cancellationInfo} />
      <View style={tailwind("items-end mt-2")}>
        <ActionButton action={availableActions.cancelSubscription} />
      </View>
    </TransactionCard>
  );
}
